import { useNavigate } from 'react-router-dom'
import { trackEvent } from 'analytics/trackFunctions'
import RoundedItem from 'components/RoundedItem'
import CreditScoreCard from './CreditScoreCard'

const InstitutionsCard = ({ list, ICONS_TO_SHOW = 3 }) => {
  const navigate = useNavigate()

  const firstItems = list.slice(0, ICONS_TO_SHOW)
  const extraNumber = list.length - ICONS_TO_SHOW

  return (
    <CreditScoreCard
      title='Información por institución'
      rightButtonAction={() => {
        trackEvent({ eventName: 'bille_sc_boton_institucion' })
        navigate('/perfil-crediticio/info-por-institucion')
      }}
    >
      <div className='flex gap-x-3 mt-5 mb-3'>
        {firstItems.map((item) => (
          <RoundedItem
            key={item.entity_code}
            imageURL={item.icon_url}
            name={item.entity_name}
          />
        ))}
        {extraNumber > 0 && (
          <div className='rounded-full bg-gray-900 w-12 h-12 text-white flex items-center font-medium text-2xl align-middle justify-center'>
            <span className='-ml-1'>+{extraNumber}</span>
          </div>
        )}
      </div>
    </CreditScoreCard>
  )
}

export default InstitutionsCard
